<template>
  <div>
    <div>
			<span class="xbed-sub-title">批量修正金额导入记录</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>订单管理</BreadcrumbItem>
				<BreadcrumbItem>支付单列表</BreadcrumbItem>
				<BreadcrumbItem>批量修正金额导入记录</BreadcrumbItem>
			</Breadcrumb>
		</div>
		<br>
    <Form inline @submit.native.prevent='preventSubmit'>
      <FormItem label='导入日期：' :label-width='100'>
        <DatePicker type='daterange' v-model="creatTime" :start-date='nowDate' placeholder="请选择使时间" class="date-time" style="width: 230px"></DatePicker>
      </FormItem>
      <FormItem>
        <Button type='primary' @click='keyWordsQuery'>查询</Button>
      </FormItem>
      <span style="color:red;margin-left:50px;">*批量修正失败的支付单金额需要人工修正</span>
    </Form>
    <Content>
      <Table stripe :columns="recordColumns" :data="recordSheetList" :loading='recordLoading' style="width:1360px;"></Table>
      <div style="margin: 10px;overflow: hidden">
				<Page show-sizer placement='top' :current='page' :page-size='size' :total='listTotal' @on-change='changePage' @on-page-size-change='changePageSize'></Page>
			</div>
    </Content>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
export default {
  created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
  data () {
    return {
      nowDate:Moment(new Date()-86400000 * 30)._d,
      creatTime:[
        Moment().subtract( 60, 'day' ).format( "YYYY-MM-DD" ),
				Moment().format( 'YYYY-MM-DD' )
      ],
      page:1,
      size:10,
      listTotal:0,
      recordSheetList:[],
      recordLoading:false,
      recordColumns:[
        {
          title:'导入文件名',
          key:'fileName',
          align:'center',
          width:240
        },
        {
          title:'处理状态',
          key:'state',
          align:'center',
          width:150,
          render: (h,params)=>{
            const status = ['','处理中','完成'][params.row.state]
            return h('div',{},status)
          }
        },
        // {
        //   title:'备注',
        //   key:'remark',
        //   align:'center',
        //   width:200,
        //   render:(h,params)=>{
        //     const remark = params.row.remark ? params.row.remark : '-'
        //     return h('div',{},remark)
        //   }
        // },
        {
          title:'导入数据量',
          key:'importNumber',
          align:'center',
          width:200
        },
        {
          title:'修正成功量',
          key:'successNumber',
          align:'center',
          width:200
        },
        {
          title:'修正失败量',
          key:'failedNumber',
          align:'center',
          width:200
        },
        {
          title:'导入时间',
          key:'createDate',
          align:'center',
          width:200,
          render:(h,params) =>{
            const date = params.row.createDate ? Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss'):''
            return h('div',{},date)
          }
        },
        {
          title:'操作人',
          key:'createName',
          align:'center',
          width:165
        },
      ]
    }
  },
  mounted () {
    this.$Notice.config( {
			top: 200
		} );
    this.queryList()
  },
  methods: {
    async queryList(){
      let param = {
        pageNum:this.page,
        pageSize:this.size,
        createTimeBegin:this.creatTime[0] ? Moment( this.creatTime[0] ).format( 'YYYY-MM-DD HH:mm:ss' ) : "",
        createTimeEnd:this.creatTime[1] ? Moment( this.creatTime[1] ).format( 'YYYY-MM-DD 23:59:59' ) : "",
        type:1
      }
      this.recordLoading = true
      const resp = (await API.omsAPI[this.env].order.batchAdjustmentRecordList(param,this.token)).data;
      this.recordLoading = false
      if ( resp.retCode ) {
        this.$Notice.error( {
          title: "获取列表失败",
          desc: resp.msg
        } );
        return
        }
      this.recordSheetList = resp.list
      this.listTotal = resp.total
    },
    keyWordsQuery(){
      this.page = 1
      this.queryList()
    },
    changePage(page){
      this.page = page
      this.queryList()
    },
    changePageSize(pageSize){
      this.page = 1
      this.size = pageSize
      this.queryList()
    },
    preventSubmit(){
      return false
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/order/import-record.vue